

import mixx from "../../../../mixin/mixin.js";

export default {
  mixins: [mixx],
  name: "api",
  data() {
    return {
      loading: false,
      loading2: false,
    };
  },

  computed: {},
  mounted: function() {

    $(".box").boxWidget();

  },



  methods: {
 
  }
};



// WEBPACK FOOTER //
// ./src/components/instructivos/api/main/index.js